<template>
  <v-card class="mb-4">
    <v-card-title>
      {{ $t('Ticket detail') }}
    </v-card-title>
    <v-card-text>
      <row-line :label="$t('Task name')">
        <router-link
          :to="{ name: 'my-workings.detail', params: { id: ticket.task_id } }"
          target="_blank"
        >
          {{ taskName }}
        </router-link>
      </row-line>
      <row-line :label="$t('Due date')"> {{ dateFormat(dueDate) }} </row-line>
      <row-line :label="$t('Project name')">
        <router-link
          :to="{ name: 'projects.show', params: { id: ticket.project_id } }"
          target="_blank"
        >
          {{ projectName }}
        </router-link>
      </row-line>
      <row-line :label="$t('Created by')">{{ createdBy }}</row-line>
      <row-line :label="$t('Content')">{{ ticket.message }}</row-line>
      <row-line :label="$t('Documents')">
        <div>
          <single-file-item
            v-for="file in ticket.files"
            :key="`file-${file.id}`"
            :file="file"
          />
        </div>
      </row-line>
      <row-line :label="$t('Created at')" :line="false">{{
        utcToLocalDateTimeLess(ticket.created_at)
      }}</row-line>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { dateFormat, utcToLocalDateTimeLess } from '@utils'
import RowLine from '@components/RowLine'
import SingleFileItem from '@/components/SingleFileItem'

export default {
  components: {
    RowLine,
    SingleFileItem
  },

  props: {
    ticket: {
      type: Object,
      required: true
    }
  },

  computed: {
    taskName() {
      return _.get(this.ticket, 'task.name')
    },
    dueDate() {
      return _.get(this.ticket, 'task.due_date')
    },
    projectName() {
      return _.get(this.ticket, 'task.project.name')
    },
    createdBy() {
      return _.get(this.ticket, 'user.name')
    }
  },

  methods: {
    dateFormat,
    utcToLocalDateTimeLess
  }
}
</script>
